// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {getStorage,
  ref,
  uploadBytes,
  getDownloadURL,} from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAeNFk6WO_B2Da8wPlqi46QBe4ORl10JGM",
  authDomain: "motel-bambu.firebaseapp.com",
  projectId: "motel-bambu",
  storageBucket: "motel-bambu.appspot.com",
  messagingSenderId: "258583891762",
  appId: "1:258583891762:web:14d6bc4890cf1f07a5912b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

var storage = getStorage(app);

export async function uploadFile(file) {
  let randomNumberMin = Math.floor(Math.random() * 10000);
  let randomNumberMax = Math.floor(Math.random() * 100000000);
  let storageRef = ref(storage, `${randomNumberMin}-transferencia-${randomNumberMax}`);
  await uploadBytes(storageRef, file);
  let url = await getDownloadURL(storageRef);
  return url;
}

export {
  storage,
  ref,
  uploadBytes,
  getDownloadURL
}

export default db;